import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store"
import './permission'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/gloable.css'
import request from "@/utils/request";

import echarts from 'echarts'
import plugins from './plugins' // plugins
import '@/assets/styles/index.scss' // global css
import '@/assets/styles/ruoyi.scss' // ruoyi css
import './assets/styles/element-variables.scss'

import Pagination from '@/components/Pagination'
import Print from 'vue-print-nb'

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
ElementUI.Select.props.popperAppendToBody.default = false;
ElementUI.DatePicker.props.appendToBody = false;
ElementUI.TimePicker.props.appendToBody = false;

/*ElementUI.DatePicker.props['append-to-body'].default = false;*/
Vue.use(ElementUI,{size:"mini",})
Vue.use(plugins)
Vue.use(Print)

Vue.component('Pagination', Pagination)

Vue.prototype.request=request

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
// 全局初始化数据：加载运输方式和平台数据
/*async function initGlobalData() {
  try {
    // 1. 加载运输方式数据（common模块的action）
    await store.dispatch('common/loadTransportation');
    console.log('运输方式数据加载完成');

    // 2. 加载平台数据（如果有）
    await store.dispatch('common/loadPlatform');
    console.log('平台数据加载完成');

  } catch (error) {
    console.error('全局数据初始化失败:', error);
    // 可以在这里显示全局错误提示（如Element的Message）
    Vue.prototype.$message.error('系统初始化失败，请刷新页面重试');
  }
}

// 先初始化数据，再挂载应用
initGlobalData().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
});*/
